var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"loader__wrapper"},[_c('div',{staticClass:"loader__inner"},[_c('span',{staticClass:"loader__text"},[_vm._v(_vm._s(_vm.loaderText))]),_vm._v(" "),_c('span',{staticClass:"loader__icon"},[_c('wifi-signal-icon')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }